export const CONTAINER_TYPE = {
    BAG: "BAG",
    CART: "CART",
    PALLET: "PALLET",
    BIN: "BIN",
    OV_BIN: "OV_BIN",
    ROUTE: "ROUTE",
    STACKING_AREA: "STACKING_AREA"
}
